import AprobarPermisosPersonalGerencia from "../../Screen/Gerencia/Permisos/AprobarPermisosPersonalGerencia";
import ComunicadosScreen from "../../Screen/Gerencia/Comunicados/ComunicadosScreen";
import ComunicadosCrudScreen from "../../Screen/Gerencia/Comunicados/ComunicadosCrudScreen";
import EncuestasScreen from "../../Screen/Gerencia/Encuestas/EncuestasScreen";

import ProcedimientosListScreen from "../../Screen/Gerencia/Procedimientos/ProcedimientosListScreen";

export const GerenciaRoutes = [
    {
        path: 'Gerencia/Permisos',
        permiso: 59,
        element: <AprobarPermisosPersonalGerencia permiso={1} /> // 1 = GA Gerencia
      },
      {
        path: 'Admin/Memorandum',
        permiso: 35,
        element: <ComunicadosScreen />
      },
      {
        path: 'Admin/Memorandum/New',
        permiso: 35,
        element: <ComunicadosCrudScreen />
      },
      {
        path: 'Admin/Memorandum/Edit/:memo',
        permiso: 35,
        element: <ComunicadosCrudScreen />
      },
      {
        path: 'Gerencia/Encuestas',
        permiso: 86,
        element: <EncuestasScreen />
      },
      {
        path: 'Gerencia/Procedimientos',
        permiso: 56,
        element: <ProcedimientosListScreen />
      },

]

export default GerenciaRoutes;